import React from 'react';
import { TxtVariants } from './Txt.css';

type TxtVariant = NonNullable<TxtVariants['variant']>;

type VariantMap<Variants extends string> = Record<Variants, React.ElementType>;

/**
 * @todo Move somewhere more useful
 */
const createVariantMapping = <Variants extends string>(map: Partial<VariantMap<Variants>>) => map;

const txtVariantMap = createVariantMapping<TxtVariant>({
  xl: 'span',
  lede: 'p',
  small: 'span',
  large: 'span',
  // button: 'button',
  body: 'p',
  bodyAlt: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
});

export const useTxtVariantMap = (value: TxtVariant, defaultComponent: React.ElementType) => {
  return txtVariantMap[value] ?? defaultComponent;
};
